import React, { useState } from 'react';
import { Input, message } from 'antd';
import api from '../api';
import './Login.css';

const TITLE = 'HỆ THỐNG DUYỆT ĐƠN KHUYẾN MÃI GK88';
const SLOGAN = 'THÀNH THẬT - TRUNG THẬT - TẬN TÂM';
const EMPTY_MFA = { step: 'password', ticket: null, qrCode: null, secret: null };

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // step: 'password' | 'setup' (lần đầu, quét QR) | 'verify' (nhập mã 2FA)
  const [mfa, setMfa] = useState(EMPTY_MFA);
  const [code, setCode] = useState('');

  const backToPassword = (msg = '') => {
    setMfa(EMPTY_MFA);
    setCode('');
    setPassword('');
    setError(msg);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    const name = username.trim();
    if (!name || !password) {
      setError('Vui lòng nhập tên đăng nhập và mật khẩu.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const response = await api.post('/auth/login', { username: name, password });
      if (response.data.status) {
        const { step, ticket, qr_code, secret } = response.data.data;
        setCode('');
        setMfa({ step, ticket, qrCode: qr_code || null, secret: secret || null });
      } else {
        setError(response.data.message || 'Tên đăng nhập hoặc mật khẩu không đúng.');
        setPassword('');
      }
    } catch (err) {
      setError('Không thể kết nối đến server. Vui lòng thử lại sau.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (value = code) => {
    if (loading) return;
    if (!/^\d{6}$/.test(value)) {
      setError('Nhập đủ 6 số từ ứng dụng Authenticator.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const response = await api.post('/auth/login/2fa', { ticket: mfa.ticket, code: value });
      if (response.data.status) {
        const { token, user } = response.data.data;
        localStorage.setItem('admin_token', token);
        localStorage.setItem('admin_user', user.username);
        message.success(response.data.message || 'Đăng nhập thành công!');
        onLogin(user);
        return;
      }
      setCode('');
      if (response.data.expired) backToPassword(response.data.message);
      else setError(response.data.message || 'Mã 2FA không đúng.');
    } catch (err) {
      setError('Không thể kết nối đến server. Vui lòng thử lại sau.');
    } finally {
      setLoading(false);
    }
  };

  const onPassword = mfa.step === 'password';
  const isSetup = mfa.step === 'setup';

  return (
    <div className="gk-auth">
      <section className="gk-auth-hero">
        <img className="gk-auth-logo" src="/logogk88.png" alt="GK88" />
        <div className="gk-auth-hero-body">
          <p className="gk-auth-kicker">Bảng điều hành</p>
          <h1>{TITLE}</h1>
          <p className="gk-auth-slogan">{SLOGAN}</p>
        </div>
        <p className="gk-auth-foot">© {new Date().getFullYear()} GK88 · Chỉ dành cho quản trị viên</p>
      </section>

      <section className="gk-auth-panel">
        <div className="gk-auth-box">
          <div className="gk-auth-mobile">
            <img src="/logogk88.png" alt="GK88" />
            <strong>{TITLE}</strong>
            <span className="gk-auth-muted">{SLOGAN}</span>
          </div>

          <ol className="gk-auth-steps">
            <li className={onPassword ? 'on' : 'done'}><b>1</b>Tài khoản</li>
            <li className={onPassword ? '' : 'on'}><b>2</b>Mã 2FA</li>
          </ol>

          {onPassword ? (
            <form onSubmit={handleLogin} noValidate>
              <h2>Đăng nhập</h2>
              <p className="gk-auth-muted">Bước 1: nhập tài khoản và mật khẩu quản trị.</p>
              <label>
                Tài khoản
                <input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  placeholder="Tên đăng nhập"
                  autoFocus
                />
              </label>
              <label>
                Mật khẩu
                <div className="gk-auth-password">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    placeholder="••••••••"
                  />
                  <button type="button" className="gk-auth-link" onClick={() => setShowPassword((v) => !v)}>
                    {showPassword ? 'Ẩn' : 'Hiện'}
                  </button>
                </div>
              </label>
              {error && <div className="gk-auth-error">{error}</div>}
              <button type="submit" className="gk-auth-submit" disabled={loading}>
                {loading ? 'Đang kiểm tra...' : 'Tiếp tục'}
              </button>
            </form>
          ) : (
            <form onSubmit={(e) => { e.preventDefault(); handleVerify(); }} noValidate>
              <h2>{isSetup ? 'Cài xác thực 2 lớp' : 'Nhập mã 2FA'}</h2>
              <p className="gk-auth-muted">
                Tài khoản <strong>{username.trim()}</strong> ·{' '}
                <button type="button" className="gk-auth-inline" onClick={() => backToPassword()} disabled={loading}>
                  Đổi tài khoản
                </button>
              </p>

              {isSetup ? (
                <div className="gk-auth-setup">
                  <p>Lần đầu đăng nhập, quét mã QR bằng <strong>Google Authenticator</strong> hoặc <strong>Authy</strong>:</p>
                  {mfa.qrCode && <img src={mfa.qrCode} alt="Mã QR 2FA" />}
                  <details>
                    <summary>Không quét được? Nhập khoá thủ công</summary>
                    <code>{mfa.secret}</code>
                    <small className="gk-auth-muted">Loại: theo thời gian (TOTP) · 6 số · 30 giây</small>
                  </details>
                </div>
              ) : (
                <p className="gk-auth-hint">
                  Bước 2: mở ứng dụng xác thực và nhập mã 6 số đang hiện cho tài khoản này.
                </p>
              )}

              <label>
                {isSetup ? 'Nhập mã 6 số vừa hiện trong ứng dụng để xác nhận' : 'Mã 2FA (6 số)'}
                <div className="gk-auth-otp">
                  <Input.OTP
                    length={6}
                    size="large"
                    value={code}
                    formatter={(v) => v.replace(/\D/g, '')}
                    onChange={(v) => {
                      setCode(v);
                      if (/^\d{6}$/.test(v)) handleVerify(v);
                    }}
                    autoFocus
                    disabled={loading}
                  />
                </div>
              </label>
              {error && <div className="gk-auth-error">{error}</div>}
              <button type="submit" className="gk-auth-submit" disabled={loading}>
                {loading ? 'Đang kiểm tra...' : isSetup ? 'Xác nhận và đăng nhập' : 'Đăng nhập'}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}

export default Login;
